export const FacebookIcon = () => <img src='/icons/facebook.svg' alt=''/>
export const AppleIcon = () => <img src='/icons/apple.svg' alt='' />
export const GoogleIcon = () => <img src='/icons/google.svg' alt='' />
export const ChangePassIcon = () => <img src='/icons/changepass-icon.png' alt='' />
